export enum DeviceKindEnum {
    //Основное оборудование
    device = 1,
    //Комплектующие
    component = 2,
    //SIM-карта
    simCard = 3,
}